import { i as o } from "./is-regexp-4c49b1c2.js";
import { E as a } from "./export-cdcbfb2b.js";
var t = o, n = TypeError, f = function(r) {
  if (t(r))
    throw new n("The method doesn't accept regular expressions");
  return r;
}, c = a, s = c("match"), g = function(r) {
  var e = /./;
  try {
    "/./"[r](e);
  } catch {
    try {
      return e[s] = !1, "/./"[r](e);
    } catch {
    }
  }
  return !1;
};
export {
  g as c,
  f as n
};
